// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606180624/js/" + chunkId + "." + {"44":"1825ab70","225":"81a7b6b7","481":"d6e7d2a6","486":"98b7152a","770":"8ab007ef"}[chunkId] + ".0.6523504052348582.chunk.js";
};